import { Action } from "../../../libs/redux/action";
import { LOAD_CAPTCHA, LOAD_CAPTCHA_DONE } from "../constants";
import { CaptchaState } from "../state";

interface LoadCaptchaPayload {
    token: string;
    codApplication: string;
}

export class LoadCaptcha extends Action<LoadCaptchaPayload, CaptchaState> {
    readonly type = LOAD_CAPTCHA;
    reducer(state: CaptchaState): CaptchaState {
        return {
            ...state,
        };
    }
}

export class LoadCaptchaDone extends Action<boolean | Error, CaptchaState> {
    readonly type = LOAD_CAPTCHA_DONE;
    reducer(state: CaptchaState): CaptchaState {
        return {
            ...state,
            done: !this.error && (this.payload as boolean),
        };
    }
}
